module.exports = __webpack_public_path__ + "media/vo-01-07.23ce7015.mp3";